import { bool } from "prop-types";
import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import {
  usePresetFieldNames,
  useEstimateEditorStore,
  useEstimateStructure,
  useVisibilityModeCellClassName,
  useEstimateEditorSettings,
  EstimateCurrencyEditor,
  ValueCell,
  VisibilityButton,
} from "@tools";

export const RateCell = observer((cellProps) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  const { currency } = structure.settings;
  const { hideSummaryRate } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryRate);
  
  return (
    <ValueCell
      colName={ SummaryColumns.RATE }
      useDynamicWidth
      isHeader
      className={className}
      style={{ cursor: allowEdition && "grab", }}
      { ...cellProps }
    >
      <span className="preset-tableSummaryHeader pt-rate">
        { `${getFieldName("pt-rate")} (${currency})` }
      </span>
      { allowEdition && <EstimateCurrencyEditor /> }
      {
        visibilityMode &&
        <VisibilityButton
          size="tiny"
          inColumn right={-8}
          hidden={hideSummaryRate}
          onChange={structure.visibility.setHideSummaryRate}
        />
      }
    </ValueCell>
  )
})

RateCell.propTypes = {
  extendPadding: bool,
}